import "@/App.css";

// Import all section components
import {
  Navigation,
  HeroSection,
  BookingSection,
  ServicesSection,
  FleetSection,
  TestimonialsSection,
  AboutSection,
  PopularDestinationsSection,
  CompetitorConquestingSection,
  BlogSection,
  ContactSection,
  Footer,
  WhatsAppButton
} from "./components/sections";

// Main App Component - Refactored with modular components
function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <HeroSection />
        <BookingSection />
        <ServicesSection />
        <FleetSection />
        <TestimonialsSection />
        <PopularDestinationsSection />
        <CompetitorConquestingSection />
        <AboutSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
